<template>
  <div class="ai rt60">
    <div>
      <banner :child-data="fdata"></banner>

      <div id="ai-main">
        <div class="" data-ani="">
          <div class="ai-sec " data-ani="">
            <div class="container">
              <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">产品演示</span>
                <p>精确追踪并识别十指的运动路径、轨迹和手势动作，将手势信息实时转化为指令信息，双手合十、比心、点赞、抱拳...多种特效一“触”即发。</p>
                <span class="line"></span>
              </div>
              <b-row>
                <b-col cols="12" md="4">
                  <video
                    muted="true"
                    loop="true"
                    preload="true"
                    class="jmod-video"
                    _stat_click_id="demo_video1"
                    controls
                  >
                    <source src="/img/v1.mp4" type="video/mp4" />
                  </video>
                </b-col>
                <b-col cols="12" md="4">
                  <video
                    muted="true"
                    loop="true"
                    preload="true"
                    class="jmod-video"
                    _stat_click_id="demo_video1"
                    controls
                  >
                    <source src="/img/v1.mp4" type="video/mp4" />
                  </video>
                </b-col>
                <b-col cols="12" md="4">
                  <video
                    muted="true"
                    loop="true"
                    preload="true"
                    class="jmod-video"
                    _stat_click_id="demo_video1"
                    controls
                  >
                    <source src="/img/v1.mp4" type="video/mp4" />
                  </video>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="ai-advantage " data-ani="">
            <div class="container">
              <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">产品优势</span>
                <span class="line"></span>
              </div>
              <b-card-group deck>
                <b-card>
                  <i class="card-img-top myicon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
              </b-card-group>
              <b-card-group deck>
                <b-card>
                  <i class="card-img-top myicon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="card-img-top myicon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
              </b-card-group>
            </div>
          </div>

          <div class="ai-scene " data-ani="">
            <div class="container">
              <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">应用场景</span>
                <span class="line"></span>
              </div>
              <b-card-group deck>
                <b-card>
                  <i class="Card image myleftIcon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="Card image myleftIcon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="Card image myleftIcon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
              </b-card-group>
              <b-card-group deck>
                <b-card>
                  <i class="Card image myleftIcon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="Card image myleftIcon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
                <b-card>
                  <i class="Card image myleftIcon"></i>
                  <b-card-text>
                    <h4>样本丰富</h4>
                    <p>立足于腾讯社交大数据平台收集的海量训练集，成功标注千万张人脸</p>
                  </b-card-text>
                </b-card>
              </b-card-group>
            </div>
          </div>

          <div class="ai-parter " data-ani="">
            <div class="container">
              <div class="develop-title">
                <span class="line"></span>
                <span class="title-text">合作案例</span>
                <span class="line"></span>
              </div>
              <div class="partner-sec">
                <b-row>
                  <b-col cols="6" md="4" lg="3">
                    <div class="container">QQ</div>
                  </b-col>
                  <b-col cols="6" md="4" lg="3">
                    <div class="container">QQ</div>
                  </b-col>
                  <b-col cols="6" md="4" lg="3">
                    <div class="container">QQ</div>
                  </b-col>
                  <b-col cols="6" md="4" lg="3">
                    <div class="container">QQ</div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topNav from "../components/top";
import banner from "../components/banner";
import footerBot from "../components/footerBot";
import { mapMutations } from "vuex";
export default {
  name: "about",
  data() {
    return {
      fdata: {
        h1: "手势识别",
        h2: "",
        style: {
          background: "#0052d9"
        }
      }
    };
  },
  components: {
    topNav,
    banner,
    footerBot
  },
  methods: {
    addActive(val) {
      this.menu = val;
    },
    ...mapMutations(["editMenu"])
  },
  mounted() {
    this.editMenu("about");
  }
};
</script>

<style scoped>
.myicon {
  width: 80px;
  height: 80px;
}
#headerwrap h2 {
  font-size: 20px;
  text-align: left;
}
blockquote {
  border: none;
}
#navbar-main {
  /* height: 144px; */
}
#about-main {
  padding-bottom: 30px;
}
#headerwrap {
  /* background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center top; */
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerwrap h1 {
  margin-top: 0;
}

#headerwrap h2 {
  color: white;
  margin-bottom: 0;
}

#ai-main .img-banner {
  height: 380px;
  width: 100%;
  /* background: url(img/about/gyks_banner@3x.jpg) no-repeat 100% center; */
  background-size: 100% 100%;
  box-sizing: border-box;
}

#ai-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}

@media screen and (max-width: 480px) {
  #ai-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center;
    background-size: 100% 100%;
  }
}
#ai-main .company-info {
  /* padding: 20px 0px; */
  box-sizing: border-box;
}
.company-develop {
  padding-top: 40px;
}
#ai-main .info-title,
#ai-main .develop-title {
  text-align: center;
  margin-bottom: 30px;
  margin-top: 20px;
}
#ai-main .info-main {
  display: flex;
  flex-direction: column;
  /* align-items: ; */
}
#ai-main .info-title .title-text,
#ai-main .develop-title .title-text {
  font-size: 30px;
}

.tab-content {
  background-color: #fff;
  border: 1px solid #ddd;
  border-top: 0;
  padding: 15px 15px 5px;
  box-sizing: border-box;
}

.well {
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0.05);
}

#headerwrap p {
  font-weight: 300;
  text-align: center;
  letter-spacing: 1px;
}
.btn-outline-primary {
  color: black;
  border-color: #ccc;
}
.btn-outline-primary:hover {
  color: white;
}
.ai-advantage {
  background: #f2f2f5;
  padding: 60px 0px 60px;
}
.ai-advantage .card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.ai-advantage .card-body .myicon {
  background-image: url(../../public/img/allicon.png);
  background-position: 0 -256px;
  margin-bottom: 20px;
}
.card-deck:nth-child(n + 1) {
  margin-top: 30px;
}
.card-text p {
  text-align: left;
}
.card {
  border: none;
  background: unset;
}
.ai-scene {
  padding: 60px 0;
}
.ai-scene .card {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ai-scene .card .card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
}
.ai-scene .card .card-body .card-text {
  flex: 1;
}
.ai-scene .card .card-body .card-text h4 {
  font-size: 18px;
}
.ai-scene .card .card-body .card-text p {
  font-size: 14px;
}
.ai-scene .card .card-body .myleftIcon {
  background-image: url(../../public/img/allicon.png);
  background-position: -269px -340px;
  width: 56px;
  height: 56px;
  display: block;
  margin-right: 20px;
}
.ai-scene .card img {
  width: 50%;
}

.ai-parter {
  background: cadetblue;
  padding: 60px;
}
.partner-sec {
  display: flex;
  align-items: center;
  justify-content: center;
}
.partner-sec .col-6 {
  margin-bottom: 20px;
}
.partner-sec > div {
  padding: 20px;
  flex: 1;
}
.partner-sec .container {
  padding: 20px;
  background-color: white;
}
.ai-parter .develop-title .title-text {
  color: white;
}
.ai-sec {
  padding: 60px 0px 60px;
}
.fileGroup {
  display: flex;
  justify-content: space-around;
  height: 350px;
}

.imgBottom {
  position: absolute;
  bottom: 0;
}

.fileGroup > div {
  width: 48%;
  position: relative;
}
@media screen and (max-width: 480px) {
  .fileGroup {
    flex-wrap: wrap;
    height: auto;
  }
  .fileGroup > div {
    width: 100%;
    position: relative;
  }
  .json_right {
    height: 300px;
  }
}

.fileGroup .json_right {
  border: 1px solid lightgray;
  height: 300px;
}

.fileGroup .imgShow {
  width: 100%;
  height: 300px;
  border: 1px solid lightgray;
}
.fileGroup .imgShow img {
  /* width: 100%; */
  height: 100%;
}
.fileGroup .json_right {
  background: aliceblue;
}
#file0,
#file1,
#file2,
#file3,
#file4,
#file5,
#file6,
#file7 {
  display: none;
}
.fileGroup .tips {
  position: absolute;
  left: 0;
  top: 0;
  padding: 5px 10px;
  background-color: #e6fafd;
  font-size: 14px;
  color: gray;
}
.btn-group {
  margin-bottom: 20px;
}
.imgSec {
  width: 100%;
  height: 100%;
  overflow: hidden;
  list-style-type: none;
}
.compare {
  width: 20%;
  margin-top: 30px;
}
.rt60 {
  position: relative;
  top: -60px;
    margin-bottom: -60px;
}
</style>
